var map = {
	"./anhui.png": "29d6",
	"./beijing.png": "382a",
	"./chongqing.png": "36c9",
	"./default-img.png": "03fa",
	"./fujian.png": "5244",
	"./gansu.png": "6d1a",
	"./guangdong.png": "e471",
	"./guangxi.png": "00b4",
	"./guizhou.png": "e6b8",
	"./hainan.png": "fb65",
	"./hebei.png": "0db4",
	"./heilongjiang.png": "f98e",
	"./henan.png": "4548",
	"./hubei.png": "cf03",
	"./hunan.png": "0d70",
	"./icon_add@2x.png": "a958",
	"./icon_day@2x.png": "d4a0",
	"./icon_month@2x.png": "7769",
	"./icon_week@2x.png": "3b5c",
	"./icon_year@2x.png": "4231",
	"./jiangsu.png": "91f4",
	"./jiangxi.png": "ac12",
	"./jiling.png": "a928",
	"./liaoning.png": "51d8",
	"./neimenggu.png": "9213",
	"./ningxia.png": "9eb3",
	"./qinghai.png": "4a927",
	"./shandong.png": "5b7c",
	"./shanghai.png": "88b5",
	"./shanxi.png": "52f9d",
	"./shanxi1.png": "5240",
	"./sichuan.png": "8f13",
	"./tianjing.png": "e22a",
	"./xizang.png": "de5f",
	"./yunnan.png": "6a0f",
	"./zejiang.png": "d8f7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ce04";